<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.subscriber.id === null ? "ADICIONAR NOVO" : "ATUALIZAR" }} ASSINANTE</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <!-- Email -->
        <vs-input
          label="Email"
          v-model="subscriber.email"
          class="mt-5 w-full"
          name="email"
          v-validate="{required: true, email: true}"
          :disabled="!!this.subscriber.id"
        />
        <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>

        <!-- First Name -->
        <vs-input
          label="Nome"
          v-model="subscriber.first_name"
          class="mt-5 w-full"
          name="first_name"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('first_name')"
        >{{ errors.first('first_name') }}</span>

        <!-- Last Name -->
        <vs-input
          label="Sobrenome"
          v-model="subscriber.last_name"
          class="mt-5 w-full"
          name="last_name"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('last_name')"
        >{{ errors.first('last_name') }}</span>

        <!-- Phone Number -->
        <vs-input
          label="Celular"
          v-model="subscriber.phone_number"
          class="mt-5 w-full"
          name="phone_number"
          v-validate="'required'"
          v-mask="['(##) ####-####', '(##) #####-####']"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('phone_number')"
        >{{ errors.first('phone_number') }}</span>

        <!-- SEGMENTS -->
        <div class="mt-3 mb-3">
          <h2 class="mb-1">Segmentos do Assinante</h2>
          <small>
            Determina quais campanhas de newsletter serão enviadas à esse assinante,
            com base nos segmentos escolhidos
          </small>

          <!-- CREATE -->
          <div v-if="subscriber.id === null" class="mt-2">
            <ul>
              <li v-for="category in categories" :key="`segment-${category.id}`" class="mb-3">
                <vs-checkbox v-model="subscriberSegments" :vs-value="category.id">{{category.name}}</vs-checkbox>
              </li>
            </ul>
          </div>

          <!-- UPDATE -->
          <div v-else class="mt-2">
            <p v-if="!subscriberSegments.length" class="mt-2">Nenhum segmento atrelado</p>

            <vs-chip
              :key="`segment-${category.id}`"
              v-for="category in subscriberSegments"
              color="dark"
              class="mt-3 mr-3"
              style="font-size: 0.9rem;"
            >{{ category.name }}</vs-chip>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Salvar</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

import moduleCategory from "@/store/category/moduleCategory";
import subscriberSegmentHttp from "@/http/requests/subscriberSegment";

export default {
  name: "subscriber-view-sidebar",
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    subscriber: {
      type: Object,
      required: false,
      default: () => {
        return {
          id: null,
          mailchimp_id: "",
          email: "",
          first_name: "",
          last_name: "",
          phone_number: ""
        };
      }
    }
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      subscriberData: {},
      categories: [],
      subscriberSegments: []
    };
  },
  watch: {
    "subscriber.id"(val) {
      if (val) {
        subscriberSegmentHttp
          .subscriberSegments(val)
          .then(res => {
            this.subscriberSegments =
              res.data.data.subscriberSegments.categories;
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.subscriberSegments = [];
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    isFormValid() {
      return !this.errors.any();
    }
  },
  methods: {
    initValues() {
      this.subscriberData = this.$_.cloneDeep(this.subscriber);
      this.subscriberSegments = [];
    },
    submitData() {
      const that = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.subscriber.id !== null && this.subscriber.id >= 0) {
            delete this.subscriber.email;
            delete this.subscriber.mailchimp_id;
            this.$store
              .dispatch("newsletterSubscriber/update", this.subscriber)
              .then(() => {
                that.initValues();
                this.$emit("closeSidebar");
              })
              .catch(err => {
                console.error(err);
              });
          } else {
            delete this.subscriber.id;
            delete this.subscriber.mailchimp_id;
            this.subscriber.subscriber_segments = `[${this.subscriberSegments.join(
              ","
            )}]`;
            this.$store
              .dispatch("newsletterSubscriber/add", this.subscriber)
              .then(() => {
                // that.initValues();
                this.$emit("closeSidebar");
                this.subscriber = {
                  id: null,
                  mailchimp_id: "",
                  email: "",
                  first_name: "",
                  last_name: "",
                  phone_number: ""
                }
                this.subscriberSegments = []
              })
              .catch(err => {
                console.error(err);
              });
          }
        }
      });
    }
  },
  mounted() {
    if (!moduleCategory.isRegistered) {
      this.$store.registerModule("category", moduleCategory);
      moduleCategory.isRegistered = true;
    }

    this.$store
      .dispatch("category/fetch", {
        activated: true,
        order_by: "name_asc"
      })
      .then(res => {
        this.categories = res.data.data.categories.items;
      })
      .catch(err => {
        console.error(err);
      });
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
